import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=0bcff581&"
import script from "./button-group.vue?vue&type=script&lang=js&"
export * from "./button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcff581')) {
      api.createRecord('0bcff581', component.options)
    } else {
      api.reload('0bcff581', component.options)
    }
    module.hot.accept("./button-group.vue?vue&type=template&id=0bcff581&", function () {
      api.rerender('0bcff581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/button-group.vue"
export default component.exports